export const employerRole = {
   admin: 'ROLE_ADMIN',
   user: 'ROLE_USER',
   compAdmin: 'ROLE_COMP_ADMIN',
   compAcct: 'ROLE_COMP_ACCT',
};

export const partnerRole = {
   admin: 'ROLE_ADMIN',
   advertiserCentralInternal: 'ROLE_ADVERTISERCENTRAL_INTERNAL',
   advertiserCentralExternal: 'ROLE_ADVERTISERCENTRAL_EXTERNAL',
   emailPlatformInternal: 'ROLE_EMAILPLATFORM_INTERNAL',
   employerCentralInternal: 'ROLE_EMPLOYERCENTRAL_INTERNAL',
   employerCentralExternal: 'ROLE_EMPLOYERCENTRAL_EXTERNAL',
   jobFeedReportExternal: 'ROLE_JOBFEEDREPORT_EXTERNAL',
   jobFeedReportInternal: 'ROLE_JOBFEEDREPORT_INTERNAL',
   mercuryInternal: 'ROLE_MERCURY_INTERNAL',
   mmrExternal: 'ROLE_MMR_EXTERNAL',
   mmrInternal: 'ROLE_MMR_INTERNAL',
   proteusInternal: 'ROLE_PROTEUS_INTERNAL',
   rondoreportsInternal: 'ROLE_RONDOREPORTS_INTERNAL',
   syndicatedPartnerInternal: 'ROLE_SYNDICATEDADPARTNER_INTERNAL',
   syndicatedPartnerExternal: 'ROLE_SYNDICATEDADPARTNER_EXTERNAL',
   syndicatedSitesPartnerInternal: 'ROLE_SYNDICATEDSITESPARTNER_INTERNAL',
   syndicatedSitesPartnerExternal: 'ROLE_SYNDICATEDSITESPARTNER_EXTERNAL',
   systemAlertsInternal: 'ROLE_SYSTEMALERTS_INTERNAL',
   uacInternal: 'ROLE_UAC_INTERNAL',
};

export const partnerAdmin = {
   jobFeed: [
      partnerRole.admin,
      partnerRole.employerCentralInternal,
   ],
   manageAlert: [
      partnerRole.admin,
      partnerRole.mmrInternal,
   ],
   sponsoredAds: [
      partnerRole.admin,
      partnerRole.advertiserCentralInternal,
   ],
   synJobFeed: [
      partnerRole.admin,
      partnerRole.jobFeedReportInternal,
   ],
   synSites: [
      partnerRole.admin,
      partnerRole.syndicatedSitesPartnerInternal,
   ],
   syndicatedSponsoredAds: [
      partnerRole.admin,
      partnerRole.syndicatedPartnerInternal,
   ],
   syndicatedJobs: [
      partnerRole.admin,
      partnerRole.jobFeedReportInternal,
   ],
};

export default {
   partner: {
      ...partnerRole,
      all: Object.values(partnerRole),
   },
   employer: {
      ...employerRole,
      all: Object.values(employerRole),
   },
};
